import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';
import { comicCoverImages } from '@/mocks/coverImages';

export default function HotRecommendSection() {
  return (
    <section id="hot" className="relative bg-foreground-950 py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-primary-500 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-accent-500 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
            <div>
              <span className="inline-block px-3 py-1 rounded-full border border-primary-500/40 text-primary-400 text-xs font-medium">
                热门推荐
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50">
                大家都在看的人气韩漫
              </h2>
            </div>
            <Link
              to="/category"
              className="text-primary-400 hover:text-primary-300 text-sm font-medium flex items-center gap-1 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-0 md:mx-0">
            {hotComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                className="flex-shrink-0 w-[180px] md:w-[200px] group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-xl bg-foreground-800 aspect-[3/4] mb-3">
                  <img
                    src={comicCoverImages[comic.slug]}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                    title={comic.title}
                  />
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {comic.rating}
                  </div>
                  <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/70 text-background-50 text-xs">
                    {comic.status}
                  </div>
                </div>
                <h3 className="text-background-50 text-sm font-medium truncate group-hover:text-primary-400 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-foreground-400 text-xs mt-1">{comic.updatedChapter}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}